import { PciRoutes } from '@/api/routes';
import { Errors } from '@/constants/errors';
import { pciApiClient } from '@/services/pciApiClient';
import type { PaymentToServerResponse } from '@/types/payment';
import { useMutation } from '@tanstack/react-query';

export const usePciPaymentToServer = () => {
  return useMutation({
    mutationFn: async (params: unknown) => {
      try {
        const response = await pciApiClient.post<PaymentToServerResponse>(
          PciRoutes.FINALIZE_PAYMENT,
          params as Record<string, unknown>
        );
        if (!response || 'error' in response) {
          throw new Error(Errors.global.failedToSendPayment);
        }
        return response;
      } catch (error: unknown) {
        throw new Error(Errors.global.failedToSendPayment, { cause: error });
      }
    },
  });
};
